import { Outlet } from 'react-router-dom';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';

/**
 * Public marketing layout — header, footer, no auth gating.
 * Renders for "/", "/about", "/services", "/contact". Authenticated portal
 * routes use ClientAppShell instead.
 */
export function PublicLayout({ isAuthenticated }: { isAuthenticated: boolean }) {
  return (
    <div className="min-h-screen flex flex-col bg-white text-brand-charcoal">
      <SiteHeader isAuthenticated={isAuthenticated} />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
